import React from "react";
import "./privacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <main className="pp-container" role="main">
      <header className="pp-header">
        <button className="pp-back" onClick={() => window.history.back()}>
          ← Retour
        </button>
        <h1 className="pp-title">Conditions d'utilisation</h1>
      </header>

      <article className="pp-content">
        <section className="pp-section">
          <h2>1. Acceptation des conditions</h2>
          <p>
            En utilisant cette application mobile Belmarket, vous acceptez
            d'être lié par les présentes conditions d'utilisation. Si vous
            n'acceptez pas ces conditions, veuillez ne pas utiliser
            l'application.
          </p>
        </section>

        <section className="pp-section">
          <h2>2. Description du service</h2>
          <p>L'application Belmarket vous permet de :</p>
          <ul>
            <li>Accéder à vos commandes et suivre leur statut</li>
            <li>Gérer votre compte client</li>
            <li>Consulter notre catalogue de produits reconditionnés</li>
            <li>Contacter notre service client</li>
          </ul>
        </section>

        <section className="pp-section">
          <h2>3. Compte utilisateur</h2>
          <p>
            Pour utiliser certaines fonctionnalités de l'application, vous devez
            créer un compte en fournissant des informations exactes et
            complètes. Vous êtes responsable de la confidentialité de vos
            identifiants.
          </p>
        </section>

        <section className="pp-section">
          <h2>4. Confidentialité et données personnelles</h2>
          <p>
            Vos données personnelles sont collectées et traitées conformément à
            notre politique de confidentialité. Nous nous engageons à protéger
            vos informations selon les standards de sécurité les plus élevés.
          </p>
        </section>

        <section className="pp-section">
          <h2>5. Utilisation acceptable</h2>
          <p>
            Vous vous engagez à utiliser l'application de manière légale et
            respectueuse. Il est interdit de :
          </p>
          <ul>
            <li>Utiliser l'application à des fins illégales</li>
            <li>Tenter de contourner les mesures de sécurité</li>
            <li>Perturber le fonctionnement de l'application</li>
          </ul>
        </section>

        <section className="pp-section">
          <h2>6. Limitation de responsabilité</h2>
          <p>
            Belmarket s'efforce de fournir un service de qualité mais ne peut
            garantir l'absence d'interruptions ou d'erreurs. Notre
            responsabilité est limitée dans les conditions prévues par la loi.
          </p>
        </section>

        <section className="pp-section">
          <h2>7. Modifications des conditions</h2>
          <p>
            Nous nous réservons le droit de modifier ces conditions à tout
            moment. Les utilisateurs seront informés des changements
            significatifs par notification dans l'application.
          </p>
        </section>

        <section className="pp-section">
          <h2>8. Contact</h2>
          <p>
            Pour toute question concernant ces conditions d'utilisation, vous
            pouvez nous contacter via :
          </p>
          <ul>
            <li>Le service client dans l'application</li>
            <li>Notre site web belmarket.com</li>
            <li>
              Email :{" "}
              <a href="mailto:support@backmarket.com">support@belmarket.com</a>
            </li>
          </ul>
        </section>

        <footer className="pp-footer">
          <small>Dernière mise à jour : Janvier 2025 — Version 1.0</small>
          <p className="pp-source">
            Source : contenu adapté depuis ton fichier fourni.
            :contentReference[oaicite:1]
          </p>
        </footer>
      </article>
    </main>
  );
}
